import Vue from 'vue'
import VueRouter from 'vue-router'
import VueGtag from 'vue-gtag'
import env from 'env'

import UserList from './pages/UserList.vue'
//import UserEdit from './pages/UserEdit.vue'
import ItemList from './pages/ItemList.vue'
//import AnswerList from './pages/AnswerList.vue'
import IDetail from './pages/IDetail.vue'
import IList from './pages/IList.vue'
//import UDetail from './pages/UDetail.vue'
import Reader from './pages/Reader.vue'
import Me from './pages/Me.vue'
import SettingHtml from './pages/SettingHtml.vue'
import SettingCalendar from './pages/SettingCalendar.vue'
import SettingUsers from './pages/SettingUsers.vue'
//import MeFavorites from './pages/MeFavorites.vue'
import MeConnect from './pages/MeConnect.vue'
import MeInventoryList from './pages/MeInventoryList.vue'
import MeStoreList from './pages/MeStoreList.vue'
import MeItemList from './pages/MeItemList.vue'
import MeSettings from './pages/MeSettings.vue'
//import CustomerList from './pages/CustomerList.vue'
//import MessageList from './pages/MessageList.vue'
//import MessageDetail from './pages/MessageDetail.vue'
//import CustomerDetail from './pages/CustomerDetail.vue'
//import CustomerList from './pages/CustomerList.vue'
//import CustomerDetail from './pages/CustomerDetail.vue'
import Login from './pages/Login.vue'
//import Agreement from './pages/Agreement.vue'
//import Policy from './pages/Policy.vue'
import SystemError from './pages/errors/System.vue'


import store from './store'

// https://stackoverflow.com/questions/57837758/navigationduplicated-navigating-to-current-location-search-is-not-allowed
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
    {
        path: '*',
        name: 'reader',
        component: Reader,
        props: true,
        meta: {
            title: 'reader',
            auth_level: '100',
            navbar: true,
        },
    },
//    {
//        path: '/me',
//        name: 'me',
//        component: Me,
//        props: true,
//        meta: {
//            title: 'me',
//            auth_level: '100',
//            navbar: true,
//        },
//    },
//    {
//        path: '/settings/users',
//        name: 'settings.users',
//        component: SettingUsers,
//        props: true,
//        meta: {
//            title: 'settings.users',
//            auth_level: '200',
//            navbar: true,
//        },
//    },
//    {
//        path: '/settings/html',
//        name: 'settings.html',
//        component: SettingHtml,
//        props: true,
//        meta: {
//            title: 'settings.html',
//            auth_level: '200',
//            navbar: true,
//        },
//    },
//    {
//        path: '/settings/calendar',
//        name: 'settings.calendar',
//        component: SettingCalendar,
//        props: true,
//        meta: {
//            title: 'settings.calendar',
//            auth_level: '200',
//            navbar: true,
//        },
//    },
//    {
//        path: '/me/connect/:provider',
//        name: 'me.connect',
//        component: MeConnect,
//        props: true,
//        meta: {
//            title: 'me.connect',
//            auth_level: '100',
//            navbar: true,
//        },
//    },
//    {
//        path: '/me/items',
//        name: 'me.items',
//        component: MeItemList,
//        props: true,
//        meta: {
//            title: 'me.items',
//            auth_level: '100',
//            navbar: true,
//        },
//    },
//    {
//        path: '/500',
//        component: SystemError
//    }
]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve({ x: 0, y: savedPosition.y })
                }, 500)
            })
        } else {
            return { x: 0, y: 0 }
        }
    }
})

router.afterEach((to, from) => {
    store.dispatch('app/data')
    store.dispatch('auth/me').then(() => {
//            document.title = store.getters.trans.pages[to.meta.title]
    })
})

Vue.use(VueGtag, {
    config: { id: env.GOOGLE_ANALYTICS, },
}, router);

export default router

